import { render, staticRenderFns } from "./studentsFilter.vue?vue&type=template&id=59d805b5&"
import script from "./studentsFilter.vue?vue&type=script&lang=js&"
export * from "./studentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports